import type { AppLocale } from '../../../supabase/functions/_shared/app-locale'
import { visualEstimateErrorMessage, type VisualEstimateErrorCode } from '../../../supabase/functions/_shared/visual-estimate-errors'

export const VISUAL_ESTIMATE_OUTCOME_MIN_LENGTH = 3
export const VISUAL_ESTIMATE_OUTCOME_MAX_LENGTH = 2000

export type DesiredOutcomeValidation =
  | { valid: true }
  | { valid: false; reason: 'required' | 'too_long'; message: string }

export function validateDesiredOutcome(value: string, locale: AppLocale): DesiredOutcomeValidation {
  const length = value.trim().length
  if (length < VISUAL_ESTIMATE_OUTCOME_MIN_LENGTH) {
    return {
      valid: false,
      reason: 'required',
      message: locale === 'es' ? 'Describe el resultado que deseas.' : 'Please describe the result you want.',
    }
  }
  if (length > VISUAL_ESTIMATE_OUTCOME_MAX_LENGTH) {
    return {
      valid: false,
      reason: 'too_long',
      message: locale === 'es' ? 'Acorta la descripción.' : 'Please shorten your description.',
    }
  }
  return { valid: true }
}

export function visualEstimateGenericError(locale: AppLocale) {
  return visualEstimateErrorMessage('ESTIMATE_GENERATION_FAILED', locale)
}

export type MeasurementMethod = 'manual' | 'quick_photo' | 'reference_photo' | 'guided_scan' | 'skip'
export type VisualEstimateFormValues = { propertyId:string;categoryId:string;desiredOutcome:string;measurementMethod:MeasurementMethod;measurements:string;fileCount:number;referenceObject?:string;referenceWidth?:number;referenceHeight?:number }
export type VisualEstimateFormError = { code:VisualEstimateErrorCode;field:string;message:string }

export function validateVisualEstimateForm(value:VisualEstimateFormValues,locale:AppLocale):VisualEstimateFormError|null {
  const fail=(code:VisualEstimateErrorCode,field:string):VisualEstimateFormError=>({code,field,message:visualEstimateErrorMessage(code,locale)})
  if(!value.propertyId)return fail('MISSING_PROPERTY','property')
  if(!value.categoryId)return fail('MISSING_SERVICE_CATEGORY','category')
  const outcome=validateDesiredOutcome(value.desiredOutcome,locale)
  if(!outcome.valid)return fail(outcome.reason==='too_long'?'DESIRED_OUTCOME_TOO_LONG':'MISSING_DESIRED_OUTCOME','outcome')
  if(!['manual','quick_photo','reference_photo','guided_scan','skip'].includes(value.measurementMethod))return fail('INVALID_MEASUREMENT_MODE','measurementMethod')
  if(value.measurementMethod==='manual'&&value.measurements.trim().length<3)return fail('MISSING_MEASUREMENT_CONTEXT','measurements')
  if(value.measurementMethod==='guided_scan'&&value.fileCount<3)return fail('INSUFFICIENT_PHOTOS','photos')
  if(value.fileCount<1)return fail('MISSING_PHOTO','photos')
  if(value.measurementMethod==='reference_photo'&&value.referenceObject==='custom'&&(!value.referenceWidth||!value.referenceHeight))return fail('MISSING_MEASUREMENT_CONTEXT','referenceWidth')
  return null
}
